import AsyncSummaryViewFactory from '@/Factories/AsyncSummaryViewFactory';
import AutoGeneratingSummaryViewModelT from '@/ViewModels/SummaryViews/AutoGeneratingSummaryViewModel';
import AutoGeneratingSummaryViewT from '@/SummaryViews/AutoGeneratingSummaryView';
import ComponentManager from '@/Management/ComponentManager';

export default class AutoGeneratingSummaryViewFactory extends AsyncSummaryViewFactory {

    public viewModel: AutoGeneratingSummaryViewModelT;
    public _summaryView: JQuery;
    public openFullScreenSummaryView: any;
    public summaryView: AutoGeneratingSummaryViewT;
    private AutoGeneratingSummaryViewModel = ComponentManager.getViewModel<typeof AutoGeneratingSummaryViewModelT>('AutoGeneratingSummaryViewModel');
    private AutoGeneratingSummaryView = ComponentManager.getSummaryView<typeof AutoGeneratingSummaryViewT>('AutoGeneratingSummaryView');

    constructor(params: any) {
        super(params);
        this.openFullScreenSummaryView = this.paramOrDefault(params.viewModel ? params.viewModel.openFullScreenSummaryView : false, false);
    }

    public getNeededProperties(): Array<any> {
        return [];
    }

    public async getElementAsync(): Promise<JQuery> {
        if (this.isDisposed)
            return null;

        if (this._summaryView != null) {
            return this._summaryView;
        }

        this.viewModel = new this.AutoGeneratingSummaryViewModel({
            locator: this.locator,
            currentPdoId: this.pdoId,
            latestPdoId: this.pdoId,
            pdTypeName: this.pdTypeName,
            showHistory: this.showHistory,
            openFullScreenSummaryView: this.openFullScreenSummaryView,
            ergName: this.ergName
        });
        await this.viewModel.initAsync(this.pdoId);
        if (this.isDisposed || this.viewModel.isDisposed)
            return null;

        this.summaryView = new this.AutoGeneratingSummaryView(this.viewModel);
        const tuple = await this.summaryView.getTupleAsync();
        if (this.isDisposed || !tuple)
            return null;

        this._summaryView = tuple.summaryView;

        return this._summaryView;
    }
}

ComponentManager.setFactory('AutoGeneratingSummaryView', AutoGeneratingSummaryViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');